import { Order, OrderUL, PatchOrderRequestedResponse, RmsOrderRequest } from '@cemex-core/cmx-api';

export enum OrderCreationIcon {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Default = '',
}

export interface OrderStrategyResponse {
  order?: Order | RmsOrderRequest | PatchOrderRequestedResponse | OrderUL;
  message: string;
  messagePartTwo?: string;
  messagePartThree?: string;
  warningMessage?: string;
  additionalMessage?: string;
  success: boolean;
  icon: OrderCreationIcon;
  modal?: boolean;
  orderId?: string | number;
  orderCode?: string | number;
  waitingList?: boolean;
  scheduleOrder?: string;
  status?: {
    statusCode: string;
    statusDesc: string;
    statusId: number;
  };
  scheduleAvailability?: boolean;
  isBlocked?: boolean;
}
